export default __webpack_public_path__ + "static/media/diamond-color-2@2x.5db2518b.png";